import { useState } from "react";
import styles from "./Newsletter.module.css";
import Modal from "../Modal";
import api from "../../services/axiosInstance";

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);

  const closeModal = () => setModal(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedEmail = email.trim().toLowerCase();

    // Frontend validation
    if (!trimmedEmail) {
      return setModal({
        type: "error",
        title: "Missing email",
        message: "Please enter your email address.",
      });
    }

    if (!emailRegex.test(trimmedEmail)) {
      return setModal({
        type: "warning",
        title: "Invalid email",
        message: "Please enter a valid email address.",
      });
    }

    setLoading(true);

    try {
      await api.post("/newsletter/subscribe", {
        email: trimmedEmail,
      });

      setEmail("");

      setModal({
        type: "success",
        title: "Subscribed 🎉",
        message: "You have been successfully added to our newsletter.",
      });
    } catch (err) {
      setModal({
        type: "error",
        title: "Oops!",
        message:
          err.response?.data?.message ||
          err.message ||
          "Subscription failed",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className={styles["newsletter-section"]}>
        <div className={styles["newsletter-content"]}>
          <div className={styles["newsletter-text"]}>
            <h2 className="text-white">
              Stay Connected with Our Newsletter
            </h2>

            <p>
              Subscribe to our newsletter to get more news,
              promo, or news services
            </p>
          </div>

          <form
            className={styles["newsletter-form"]}
            onSubmit={handleSubmit}
          >
            <input
              className={styles["newsletter-form-input"]}
              type="email"
              placeholder="Enter email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />

            <button type="submit" disabled={loading}>
              {loading ? "Subscribing..." : "Subscribe"}
            </button>
          </form>
        </div>
      </section>

      {modal && (
        <Modal
          type={modal.type}
          title={modal.title}
          message={modal.message}
          onClose={closeModal}
        />
      )}
    </>
  );
};

export default Newsletter;